import React from 'react';
import Ceramic from '../images/ceramic.png';
import M_and_E from '../images/m_and_e.png';
import Facades from '../images/facades.png';

export default function companyLinks() {
  return (
    <div>
      <div className='container-fluid d-flex flex-column align-items-center flex-md-row justify-content-md-around p-4 my-3 mt-4 bg-light '>
        <a href='http://www.sturminsterelectrical.co.uk'>
          <img
            src={M_and_E}
            className='my-3 m-md-0'
            alt='http://www.sturminsterelectrical.co.uk'
            style={{ width: 'auto', height: 'auto' }}
          />
        </a>
        <a href='http://www.sturminsterfacades.co.uk'>
          <img
            src={Facades}
            className='my-3 m-md-0'
            alt='http://www.sturminsterfacades.co.uk'
            style={{ width: 'auto', height: 'auto' }}
          />
        </a>
        <a href='http://www.sturminsterceramic.co.uk'>
          <img
            src={Ceramic}
            className='my-3 m-md-0'
            alt='http://www.sturminsterceramic.co.uk'
            style={{ width: 'auto', height: 'auto' }}
          />
        </a>
      </div>
    </div>
  );
}
